export default "__VITE_ASSET__DjVHc50Q__"